import { Injectable, Pipe, PipeTransform } from "@angular/core"

@Pipe({
  name: "list",
})
export class TrListPipe implements PipeTransform {
  public transform(items: string[], separator: string = ", ", limitAmount?: number): string {
    if (!items) {
      return ""
    }

    if (typeof items === "string") {
      return items || ""
    }

    const value = items.slice(0, limitAmount).join(`${separator} `)
    if (items.length > limitAmount) {
      return `${value}...`
    }

    return value || ""
  }
}
